import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container-full-5" }
const _hoisted_2 = {
  key: 0,
  style: {"height":"300px","display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "card flex-mobile align-items-center px-6 py-1 border-grey mb-5" }
const _hoisted_5 = { class: "s7_mobile my-6" }
const _hoisted_6 = { class: "secondary-font text-grey-800 mb-3" }
const _hoisted_7 = { class: "text-grey-600 secondary-font mb-3" }
const _hoisted_8 = { class: "font-semibold secondary-font text-medium text-grey-600 mb-4" }
const _hoisted_9 = { class: "tag-state notif stroke" }
const _hoisted_10 = {
  class: "s13_mobile text-right",
  style: {"display":"flex","align-items":"center","justify-content":"end","gap":"25px"}
}
const _hoisted_11 = ["src", "title"]
const _hoisted_12 = {
  key: 2,
  style: {"height":"300px","display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_13 = { style: {"display":"flex","flex-direction":"row","justify-content":"center"} }

import { formatAmount, formatDateFrench } from '@/utils/formatters';
import axios from 'axios';
import { inject, onMounted, reactive, ref, toRaw } from 'vue';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'FrontOfficeCommandes',
  setup(__props) {

const BACKEND_URL = inject('BACKEND_URL');
const router = useRouter();
const layout = ref('none');
const loading = ref(false);
const errorMessage = ref('');

const itemsList = ref([] as any[]);
const queryParams = reactive({
    pageNumber: 1,
});
const pagination = reactive({
    total: 0,
    per_page: 16,
    last_page: 1
});
onMounted(() => {
  layout.value = router.currentRoute.value.meta.layout as string || 'none';
    doGetCommandes();
});

async function doGetCommandes() {
    try {
        loading.value = true;
        errorMessage.value = '';
        const queryParamsRaw = toRaw(queryParams);
        const queryString = new URLSearchParams(Object.fromEntries(Object.entries(queryParamsRaw).map(([k,v]) => [k, String(v)]))).toString();
        const httpResponse = await axios.get(`/market/commands?${queryString}`);
        itemsList.value = httpResponse.data.data;
        pagination.total = httpResponse.data.total;
        pagination.per_page = httpResponse.data.per_page;
        pagination.last_page = httpResponse.data.last_page;
    } catch(error: any) {
        errorMessage.value = error.message;
    } finally {
        loading.value = false;
    }
}

function onPaginate(pageNumber: number) {
    queryParams.pageNumber = pageNumber;
    doGetCommandes();
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_custom_pagination = _resolveComponent("custom-pagination")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("section", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "secondary-font gap-4 mt-2 mb-6" }, " Mes Commandes ", -1)),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("div", { class: "loader dark" }, null, -1)
          ]))]))
        : _createCommentVNode("", true),
      (!loading.value && itemsList.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsList.value, (item, index) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                to: '/front/market/commandes/' + item.id,
                key: index
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("h3", _hoisted_6, "#" + _toDisplayString(item.num_commande), 1),
                      _createElementVNode("h5", _hoisted_7, _toDisplayString(_unref(formatAmount)(item.total || item.sous_total)) + " F CFA", 1),
                      _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(formatDateFrench)(item.created_at)), 1),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(item.statut), 1)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.produits.slice(0, 3), (product, subindex) => {
                        return (_openBlock(), _createElementBlock("img", {
                          src: _unref(BACKEND_URL) + '/assets/market_produits/300/' + product.image,
                          style: {"max-height":"110px","max-width":"110px"},
                          title: product.nom,
                          key: subindex
                        }, null, 8, _hoisted_11))
                      }), 128))
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (!loading.value && itemsList.value.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("div", { class: "text-center mt-40 mb-40" }, [
              _createElementVNode("h3", { class: "secondary-font font-semibold" }, "Aucune commande enregistré")
            ], -1)
          ]))]))
        : _createCommentVNode("", true),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "clear-both h-70" }, null, -1)),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_custom_pagination, {
          modelValue: queryParams.pageNumber,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((queryParams.pageNumber) = $event)),
            onPaginate
          ],
          total: pagination.total,
          "per-page": pagination.per_page,
          last_page: pagination.last_page
        }, null, 8, ["modelValue", "total", "per-page", "last_page"])
      ])
    ])
  ]))
}
}

})